import { jsx as _jsx } from "react/jsx-runtime";
import "./FeedbackButton.scss";
import { t } from "i18next";
import config from "../../../../config";
const FeedbackButton = () => {
    return (_jsx("a", { className: "feedback-button", href: config.FEEDBACK_URL, target: "_blank", rel: "noreferrer", children: t("feedback") }));
};
export default FeedbackButton;
